/**
 * 字典选择器组件 - 基于数据字典的统一选择器
 */

import React from 'react';
import { Select, SelectProps } from 'antd';
import { useDict } from '../../../hooks/useUnifiedDict';

export interface DictSelectProps extends Omit<SelectProps, 'options'> {
  dictType: string;
  placeholder?: string;
  allowClear?: boolean;
  showSearch?: boolean;
  filterOption?: boolean | ((input: string, option: any) => boolean);
  loading?: boolean;
}

const DictSelect: React.FC<DictSelectProps> = ({
  dictType,
  placeholder = '请选择',
  allowClear = true,
  showSearch = true,
  filterOption = true,
  loading: externalLoading,
  ...restProps
}) => {
  const { options, loading: dictLoading, error } = useDict(dictType);

  const isLoading = externalLoading || dictLoading;

  // 如果加载失败，显示错误信息
  if (error) {
    return (
      <Select
        {...restProps}
        placeholder="字典加载失败"
        disabled
        options={[]}
      />
    );
  }

  return (
    <Select
      {...restProps}
      placeholder={placeholder}
      allowClear={allowClear}
      showSearch={showSearch}
      filterOption={filterOption}
      loading={isLoading}
      options={options}
    />
  );
};

export default DictSelect;
